<app-dialog
  [title]="bulkTypeName ? bulkTypeName : 'Import Bulk'"
  [actions]="actions"
  (action)="action($event)"
  (close)="close()"
> 
  <div class="error-message" *ngIf="error">Error saving {{uploadedData.length}} out of {{successCount}} rows. See errors below</div>
  <app-bulk-dialog-upload *ngIf="!uploadedData.length" (data)="uploadData($event)"></app-bulk-dialog-upload>
  <app-bulk-dialog-grid *ngIf="uploadedData.length" [rowData]="uploadedData" [gridOptions]="gridOptions"></app-bulk-dialog-grid>
</app-dialog>
